import {useMutation, UseMutationResult} from '@tanstack/react-query';
import {useLocale} from 'state/locale';
import Api from 'types/api';
import {request} from 'utils/request-axios';

export type VerifyCodeErrorResponse = Api.Response.Failure<'message'>;
export type VerifyCodeSuccessResponse = Api.Response.Success<never>;
type DXCodeInfo = {
    code: string;
};
const useGetDXCodeInfo = (): UseMutationResult<
    VerifyCodeSuccessResponse,
    VerifyCodeErrorResponse,
    DXCodeInfo
> => {
    const locale = useLocale();
    return useMutation({
        mutationFn: ({code}: DXCodeInfo) =>
            request({
                locale,
                method: 'GET',
                url: `/dx/${code}/info/`,
            }),
    });
};

export default useGetDXCodeInfo;
